import type { InFieldUser } from '@cognite/apm-client';
import { createContext } from 'react';

export const CurrentUserContext = createContext<{
  user: InFieldUser;
} | null>(null);
